// dependencies imports ⇒
import React from "react";
// assets and scss imports ⇒
import "./abhaPatientDetailsModal.scss";
import WarningIcon from "../../../../assets/warning_blue.svg";

// project file imports(UI components) ⇒
import C2CMiddlePopup from "../../Popups/C2CMiddlePopup";
import moment from "moment";
import { PROD } from "../../config";

// const file imports(helper methods, etc) ⇒

const AbhaPatientDetailsModal = (props) => {
  // const declarations ⇒
  const { appointmentDetails, abhPatientDetails, handleYes, handleNo } = props;

  // let or var declarations ⇒

  // life cycle methods ⇒

  // API Calls ⇒

  // Helper methods ⇒
  const getAbhaAddress = (abhaAddress) => {
    return `${
      abhaAddress + (process.env.REACT_APP_ENV !== PROD ? "@sbx" : "@abdm")
    }`;
  };

  // Actions ⇒

  // create UI ⇒

  const getLabelAndData = (label, data) => {
    return (
      <div className="adw-content-wrapper">
        <div className="adw-label">{label}</div>
        <div className="adw-data">{data ?? "-"}</div>
      </div>
    );
  };

  const renderAbhaPatientDetails = () => {
    return (
      <div className="abha-details-wrapper">
        <div className="abw-left-content">
          <div className="adw-heading">Existing Patient Details</div>
          <div>
            {getLabelAndData("Patient Name", appointmentDetails?.patient_name)}
          </div>
          <div>
            {getLabelAndData(
              "Date of Birth",
              appointmentDetails?.patient_dob &&
                moment(appointmentDetails?.patient_dob).format("DD/MM/YYYY")
            )}
          </div>
          <div className="adw-last-data">
            {getLabelAndData("Gender", appointmentDetails?.patient_gender)}
          </div>
        </div>
        <div className="abw-right-content">
          <div className="adw-heading">ABHA Patient Details</div>
          <div>{getLabelAndData("Patient Name", abhPatientDetails?.name)}</div>
          <div>
            {getLabelAndData(
              "Date of Birth",
              abhPatientDetails?.dob &&
                moment(abhPatientDetails?.dob).format("DD/MM/YYYY")
            )}
          </div>
          <div className="adw-last-data">
            {getLabelAndData("Gender", abhPatientDetails?.gender)}
          </div>
        </div>
      </div>
    );
  };

  const renderAbhaPatientDetailsContent = () => {
    return (
      <C2CMiddlePopup
        openPopup={true}
        hideCloseIcon={true}
        dialogClassName="abha-patient-details-modal"
        title={"Confirmation!"}
        subtitle={
          <span>
            Patient Details will be updated as per the ABHA Address
            <b>
              {" "}
              "{getAbhaAddress(
                appointmentDetails?.preferred_abha_address
              )}".{" "}
            </b>
            Do you want to continue ?
          </span>
        }
        titleImg={WarningIcon}
        leftBtn={"Yes"}
        rightBtn={"No"}
        handleLeftBtnClick={handleYes}
        handleRightBtnClick={handleNo}
      >
        {renderAbhaPatientDetails()}
      </C2CMiddlePopup>
    );
  };

  return (
    <div className="abha-patient-details-modal-container">
      {renderAbhaPatientDetailsContent()}
    </div>
  );
};

// export ⇒

export default AbhaPatientDetailsModal;
